export default {
    CurrentProfileID: state => state.currentProfileID,
    MemberData: state => state.memberData,
    GalleryData: state => state.galleryData,
    PersonalityData: state => state.personalityData,
    InterestsData: state => state.interestsData,
};